import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type ServiceEventCloseoutPolicy = DatabaseCode;

const toBaseline: ServiceEventCloseoutPolicy = {
  code: "TO_BASELINE",
  displayValue: {
    id: "common.entity.serviceeventcloseoutpolicy.tobaseline",
    defaultMessage: "To Baseline",
  },
};

export const serviceEventCloseoutPolicy = {
  toBaseline,
};

export const serviceEventCloseoutPolicies: ServiceEventCloseoutPolicy[] = Object.values(serviceEventCloseoutPolicy);

export const toServiceEventCloseoutPolicy = (code: string): ServiceEventCloseoutPolicy =>
  toDatabaseCode(code, serviceEventCloseoutPolicies);

export const toServiceEventCloseoutPolicySafely = (
  code: string | undefined,
  defaultValue: ServiceEventCloseoutPolicy | undefined = undefined
): ServiceEventCloseoutPolicy | undefined => toDatabaseCodeSafely(code, serviceEventCloseoutPolicies, defaultValue);
